/* eslint-disable no-param-reassign, max-params */

const initialState = {
  shownDAGuestCheckoutModal: false
};

const digitalAssetsModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    shownDAGuestCheckoutModal: state => state.shownDAGuestCheckoutModal,
    allowPurchaseDigitalAssets: (state, getters, rootState, rootGetters) =>
      rootGetters.accountPresent || !rootGetters.orderGroups.groups[rootGetters.digitalShippingRule]
  },

  mutations: {
    showDAGuestCheckoutModal(state) {
      state.shownDAGuestCheckoutModal = true;
    },
    hideDAGuestCheckoutModal(state) {
      state.shownDAGuestCheckoutModal = false;
    }
  }
};

export default digitalAssetsModule;
